import gql from 'graphql-tag';

import type { PartialBlog } from 'src/data/blog';
import { executeGqlQuery } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

const QUERY = gql`
  query BlogSectionsContent($projectId: ID!, $draftId: ID!) {
    blogSectionsContent(projectId: $projectId, draftId: $draftId) {
      status
      text
      headline
      sectionId
      errorMessage
    }
  }
`;

export const queryBlogSectionsContent = async (projectId: ID, draftId: ID) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables: {
      projectId,
      draftId,
    },
  });

  return getSingleProp<PartialBlog>(result.data);
};
